import { render, staticRenderFns } from "./IvyActivations.vue?vue&type=template&id=fa00b618&"
import script from "./IvyActivations.vue?vue&type=script&lang=js&"
export * from "./IvyActivations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports